import React, { useState } from 'react';
import  '../../styles/Sidebar.css';
import  '../../styles/Dashboard.css';

import UserTimesheet from '../../components/UserTimesheetPage';


function UserTimesheetPage() {
    return (
        <div className="dashboard-layout"> 
            <UserTimesheet />
        </div> 
    );
}

export default UserTimesheetPage;
